import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface TargetYearbooks {
  name: string;
  api_token: string;
}

export interface TargetYearbooksListInfor {
  errors: unknown;
  targetYearbooks: TargetYearbooks;
  isAuthenticated: boolean;
}

@Module
export default class TargetYearbooksModule
  extends VuexModule
  implements TargetYearbooksListInfor
{
  errors = {};
  targetYearbooks = {} as TargetYearbooks;
  isAuthenticated = !!JwtService.getToken();

  get TargetYearbooks() {
    return this.targetYearbooksListData;
  }

  @Mutation
  [Mutations.TARGET_YEARBOOKS_LIST_LIST_DATA](TargetYearbooks) {
    this.targetYearbooksListData = TargetYearbooks;
  }

  @Action
  [Actions.TARGET_YEARBOOKS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/chitieu_niengiam", payload)
        .then((data) => {
          this.context.commit(Mutations.TARGET_YEARBOOKS_LIST_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TARGET_YEARBOOK_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("chitieu_niengiam/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.TARGET_YEARBOOKS_LIST_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TARGET_YEARBOOK_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/chitieu_niengiam",
        "upsert",
        id,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.TARGET_YEARBOOKS_LIST_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TARGET_YEARBOOK_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/chitieu_niengiam",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.TARGET_YEARBOOKS_LIST_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
